import { useAuth } from "@/context/AuthContext";

/**
 * LO QUE SE VE CUANDO NO SE SABE SI HAY SESIÓN, que no es la pantalla de acceso.
 *
 * DE DÓNDE SALE. Del 24 de septiembre de 2026: a Gabri le apareció el formulario de acceso
 * mientras compartía pantalla con la clase, con la sesión intacta. El servidor no había
 * contestado a «¿quién soy?» y la aplicación lo tomó por «no hay nadie». Pedirle la contraseña a
 * alguien que ya la había puesto es, además de falso, lo peor que se puede hacer delante de
 * treinta alumnos: parece que la plataforma le ha echado.
 *
 * Así que cuando no se sabe, se dice que no se sabe. Y se ofrece lo único que puede arreglarlo
 * —volver a preguntar—, más la salida de emergencia por si de verdad hace falta entrar.
 */
export default function SesionSinRespuesta() {
  const { reintenta } = useAuth();
  return (
    <div className="min-h-[calc(100vh-4rem)] dvh:min-h-[calc(100svh-4rem)] bg-white flex items-center justify-center px-6">
      <div className="max-w-md text-center">
        <div className="font-mono-alpha text-[10px] uppercase tracking-[0.22em] text-alpha-red">
          Sin respuesta
        </div>
        <h1 className="mt-2 text-2xl text-alpha-black">No hemos podido comprobar tu sesión</h1>
        <p className="mt-3 text-sm text-alpha-black/60">
          El servidor no ha contestado. <strong className="text-alpha-black">No has salido</strong>:
          tu sesión sigue donde estaba. Suele ser cosa de la conexión o de un momento de mucha
          gente a la vez.
        </p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <button type="button" onClick={reintenta}
            className="px-5 py-2 rounded-full bg-alpha-red text-white text-sm hover:brightness-110 transition">
            Volver a intentarlo
          </button>
          <a href="/login"
            className="px-4 py-2 rounded-full border border-alpha-black/15 text-alpha-black/60 text-sm hover:text-alpha-black transition">
            Entrar con mi cuenta
          </a>
        </div>
      </div>
    </div>
  );
}
